export const NDA_LINK = 'https://www.playbookux.com/nda/';
export const TERMS_AND_SERVICES_LINK = 'https://www.playbookux.com/terms-conditions/';
